module.exports = __webpack_public_path__ + "static/img/1889_phase_function_Paper_PointsHejduk_Prediction.0bc4568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1889_phase_function_Paper_PointsHejduk_Prediction.png
// module id = k6oO
// module chunks = 0